"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PACIFIC_TIME_ZONE = void 0;
/** Shared timezone identifiers used across backend and frontend code. */
exports.PACIFIC_TIME_ZONE = 'America/Los_Angeles';
